var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9601 1.59244L11.8474 11.7756C11.688 12.4943 11.2724 12.6732 10.6817 12.3346L7.46265 9.9102L5.90939 11.437C5.7375 11.6127 5.59374 11.7597 5.26246 11.7597L5.49373 8.40892L11.4599 2.89888C11.7193 2.66251 11.4036 2.53154 11.0567 2.76792L3.68107 7.51453L0.505785 6.49877C-0.184902 6.27837 -0.197403 5.79285 0.649547 5.45426L13.0694 0.563904C13.6445 0.343502 14.1476 0.694867 13.9601 1.59244Z",
    fill: "#FF7905"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.5b4198e9372f90c4d751a59b986ea8b7.svg";
export { ForwardRef as ReactComponent };